import React, { useEffect, useState } from "react";
import api from "../../services/Api";

const outputs = [16, 17, 18, 19, 21, 22, 23, 25, 26, 27, 32, 33];
export default function PinEfectorSelect({ dispositivoId, efectorId, value, disabled, allowOccupied = false, ...props }) {
  const [options, setOptions] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setOptions([]); setError(""); setLoading(true);
    if (!dispositivoId) { setLoading(false); return; }
    api.get('/Sensores/pines-libres', { params: { dispositivoId, signalType: 2, efectorId } })
      .then(r => { if (!cancelled) setOptions((r.data.opciones || []).filter(o => outputs.includes(Number(o.pin.slice(1))))); })
      .catch(() => { if (!cancelled) setError('No se pudieron consultar los GPIO. Actualiza antes de elegir.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [dispositivoId, efectorId, revision]);
  return <>
    <select {...props} value={value} disabled={disabled || loading || !dispositivoId || !!error}>
      <option value="">{loading ? 'Consultando GPIO…' : 'Seleccione un GPIO libre'}</option>
      {value && !options.some(o => Number(o.pin.slice(1)) === Number(value)) && <option value={value} disabled>GPIO{value} · asignación no compatible</option>}
      {options.map(o => <option key={o.pin} value={o.pin.slice(1)} disabled={o.ocupado && !allowOccupied}>
        {o.etiqueta}{o.ocupado ? ` · ocupado: ${o.motivo}` : ' · disponible'}
      </option>)}
    </select>
    <button type="button" className="text-sm underline mt-1 py-2 disabled:opacity-50" disabled={disabled || loading || !dispositivoId} onClick={() => setRevision(r => r + 1)}>Actualizar pines disponibles</button>
    {error && <p role="alert">{error}</p>}
  </>;
}
